import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion'
import { array, func, object, string } from 'prop-types'
import { updateCenter } from '../../../store/Actions/MapActions'
import { updateSignsCache } from '../../../store/Actions/SignsActions'
import OrderBar from '../OrderBar'
import ListSigns from '../ListSigns'
import 'react-accessible-accordion/dist/fancy-example.css'

class OrderAccordion extends Component {
  checkCoord = coord => {
    if (coord.geometry.type === 'LineString') {
      return JSON.parse(coord.geometry.coordinates)[0]
    } else {
      return JSON.parse(coord.geometry.coordinates)
    }
  }

  handleListClick = order => {
    this.props.updateSignsCache({ signs: order.properties.signs })
    this.props.updateCenter(this.checkCoord(order))
  }

  render() {
    const { order, theme } = this.props
    return (
      order.properties.signs.length > 0 && (
        <Accordion onClick={() => this.handleListClick(order)}>
          <AccordionItem>
            <AccordionItemTitle>
              <OrderBar order={order} theme={theme} />
            </AccordionItemTitle>
            <AccordionItemBody>
              <ListSigns signs={order.properties.signs} />
            </AccordionItemBody>
          </AccordionItem>
        </Accordion>
      )
    )
  }
}

const OrdersEnum = ({ orders, updateCenter, updateSignsCache, theme }) =>
  orders.map(order => (
    <OrderAccordion
      order={order}
      key={`${order.properties.order_number}${order.geometry.coordinates}`}
      updateSignsCache={updateSignsCache}
      updateCenter={updateCenter}
      theme={theme}
    />
  ))

OrdersEnum.propTypes = {
  orders: array.isRequired,
  updateCenter: func.isRequired,
  updateSignsCache: func.isRequired,
  theme: string.isRequired,
}

OrderAccordion.propTypes = {
  order: object.isRequired,
  updateCenter: func.isRequired,
  updateSignsCache: func.isRequired,
  theme: string.isRequired,
}

const mapStateToProps = ({ signsState, spi }) => ({
  orders: signsState.cache.orders,
  theme: spi.theme,
})

const mapDispatchToProps = dispatch => ({
  updateCenter: value => dispatch(updateCenter(value)),
  updateSignsCache: value => dispatch(updateSignsCache(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(OrdersEnum)



// WEBPACK FOOTER //
// ./src/components/List/OrdersEnum/index.jsx